export default __webpack_public_path__ + "static/media/sponsor.d909e479.png";